'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PushCartContainer = PushCartContainer;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _PushCart = require('../components/PushCart/PushCart');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function PushCartContainer() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      action = _ref.action,
      submitTo = _ref.submitTo,
      message = _ref.message,
      subtitle = _ref.subtitle,
      cards = _ref.cards,
      upsellTitle = _ref.upsellTitle,
      upsellProducts = _ref.upsellProducts,
      productLimit = _ref.productLimit;

  return _react2.default.createElement(_reactRedux.Provider, { store: window.store }, _react2.default.createElement(_PushCart.PushCart, {
    action: action,
    submitTo: submitTo,
    message: message,
    subtitle: subtitle,
    cards: cards,
    upsellTitle: upsellTitle,
    upsellProducts: upsellProducts,
    productLimit: productLimit
  }));
}

PushCartContainer.defaultProps = {
  message: '',
  subtitle: null,
  cards: [],
  upsellTitle: '',
  upsellProducts: [],
  productLimit: 0
};

PushCartContainer.propTypes = {
  action: _propTypes2.default.string.isRequired,
  submitTo: _propTypes2.default.string.isRequired,
  message: _propTypes2.default.string,
  subtitle: _propTypes2.default.string,
  cards: _propTypes2.default.array,
  upsellTitle: _propTypes2.default.string,
  upsellProducts: _propTypes2.default.array,
  productLimit: _propTypes2.default.number
};